import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/User/UserSlices";
import sponsorReducer from "../slices/Sponsors/SponsorSlices";
import permissionsReducer from "../slices/Permissions/PermissionSlice";
import sideMenuReducer from "../slices/SideMenu/SideMenuSlices";
import auditLogs from "../slices/AuditLogs/AuditLogsSlices";
import session from "../slices/Session/Session";
import { loadState } from "../sessionstorage";
import ingredientReducer from "../slices/ActiveIngredients/IngredientSlice";
import productReducer from "../slices/Product/ProductSlices";
import controlledVocabulariesReducer from "../slices/ControlledVocabularies/ControlledVocabulariesSlice";

const persistedState = loadState();

export const store = configureStore({
  preloadedState: persistedState,
  reducer: {
    user: userReducer,
    sponsor: sponsorReducer,
    permissions: permissionsReducer,
    sideMenu: sideMenuReducer,
    auditLogs: auditLogs,
    session: session,
    ingredient: ingredientReducer,
    product:productReducer,
    controlledVocabularies: controlledVocabulariesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
